export default __webpack_public_path__ + "static/media/register.fd144dd7.svg";